import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import styles from './DataSyncLoading.module.scss';
import dynamicBarGraph from '@/assets/lottie/Dynamic Bar Graph.json';

const loadingMessages = [
    "Hang tight! We're fetching your data.",
    "Fetching the good stuff…",
    "Your dashboard is on its way!",
    "Data in progress, please don't go anywhere!"
];

export const DataSyncLoading: React.FC = () => {
    const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

    // Loading message rotation
    useEffect(() => {
        const interval = setInterval(() => {
            setLoadingMessageIndex(prev => (prev + 1) % loadingMessages.length);
        }, 2000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className={styles.container}>
            <div className={styles.iconWrapper}>
                <Lottie
                    animationData={dynamicBarGraph}
                    className={styles.lottieAnimation}
                    loop={true}
                    autoplay={true}
                />
            </div>

            <div className={styles.textContainer}>
                <h3 className={styles.title}>
                    {loadingMessages[loadingMessageIndex]}
                </h3>
                <p className={styles.subtitle}>Please wait while we synchronize your data, refresh after a moment to see your dashboard. </p>
            </div>
        </div>
    );
};
